.discord-message .discord-message-body .discord-spoiler {
	background-color: #202225;
	color: transparent;
	cursor: pointer;
}

.discord-light-theme .discord-message .discord-message-body .discord-spoiler {
	background-color: #b9bbbe;
}

.discord-message .discord-message-body .discord-spoiler:hover {
	background-color: rgba(32, 34, 37, 0.8);
}

.discord-light-theme .discord-message .discord-message-body .discord-spoiler:hover {
	background-color: rgba(185, 187, 190, 0.8);
}

.discord-message .discord-message-body .discord-spoiler--revealed {
	color: inherit;
	background-color: hsla(0, 0%, 100%, 0.1);
}

.discord-light-theme .discord-message .discord-message-body .discord-spoiler--revealed {
	background-color: rgba(0, 0, 0, 0.1);
}
